export const getAnchor = () => {
    return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
}

export const pluralizer = (word) => {
    if(word[word.length-1]==='y'){
        return `${word.slice(0, -1)}ies`
    } else {
        return `${word}s`
    }
}

export const capitalizer = (word) => {
    return word.charAt(0).toUpperCase()+word.slice(1).toLowerCase()
}